import Vue from 'Vue'
import {apiUrl, alert} from '../../helper'
import $ from 'jquery'

export default {
  data () {
    return {
      cpwpage: 1,
      cpwperPage: 10,
      cpwtotal: 0,
      commentList: [],
      content: '',
      // 默认不匿名
      anonym: 0,
      pid: 0,
      showComments: false,
      commentinput: false,
      showall: false,
      sendagain: true,
      fixShow: 2
    }
  },
  methods: {
    zan: function (i, e) {
      var tar = e.target
      var $tar = $(tar)
      if ($tar.parent().parent().hasClass('reply-operate-been') || $tar.parent().hasClass('reply-operate-been')) {
        return false
      }

      $.ajax({
        url: apiUrl('/V1.0.0/notice/commentzan'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify({'id': i})
      }).done((response) => {
        if (response.status === 0) {
          console.log('success')
          var tar = e.target
          var $tar = $(tar)
          if ($tar.parent().hasClass('footer-zan')) {
            $tar.parent().addClass('reply-operate-been')
            $tar.next("span").text(parseInt($tar.next("span").text()) + 1)
            return false
          }
          if ($tar.parent().parent().hasClass('reply-operate-hot')) {
            $tar.parent().parent().removeClass('reply-operate-hot').addClass('reply-operate-been')
            $tar.next("span").text(parseInt($tar.next("span").text()) + 1)
            return false
          }
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    showALL: function () {
      this.showall = true
    },
    getCommentcount: function (n, m) {
      let query = {'md5': m, 'typ': n}
      $.ajax({
        url: apiUrl('/V1.0.0/notice/commentcount'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        if (response.status == 0) {
          this.cpwtotal = response.data
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    getCommentList: function (p, n, m) {
      console.log(m)
      if (!this.sendagain) {
        return false
      }
      this.sendagain = false
      if (n === 1) {
        var query = {'page': p, 'perPage': this.cpwperPage, 'md5': m, 'typ': 1}
      }
      if (n === 2) {
        var query = {'page': p, 'perPage': this.cpwperPage, 'md5': m, 'typ': 2}
      }
      $.ajax({
        url: apiUrl('/V1.0.0/notice/commentlist'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        this.sendagain = true
        if (response.status == 0) {
          this.cpwtotal = response.total
          console.log("输出评论总数")
          console.log(this.cpwtotal)
          if (response.lists.length === 0) {
            return false
          } else {
            this.cpwpage = p
          }
          if (this.cpwpage == 1) {
            this.commentList = []
            // this.commentList = response.lists
            let tmp = response.lists
            for (let x of tmp) {
              if (x.replys && x.replys.length > 0) {
                // let vv = tmp[x]
                // vv.showall = 2
                let a = 2
                // a = 2
                x.showall = a
                // tmp[x].$set('showall', 2)
              }
            }
            this.commentList = tmp
            // for (let i in this.commentList) {
            //   if (this.commentList[i].replys && this.commentList[i].replys.length > 0) {
            //     this.$set('commentList[i].showall', 2)
            //   }
            // }
            console.log(this.commentList)
          } else {
            // this.commentList = this.commentList.concat(response.lists)
            let tmp = this.commentList.concat(response.lists)
            for (let x of tmp) {
              if (x.replys && x.replys.length > 0) {
                x.showall = 2
              }
            }
            this.commentList = tmp
          }
          console.log(this.commentList)
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        this.sendagain = true
        alert('请求失败')
      })
    },
    addComment: function (n, m, y, z) {
      if (!this.content.trim()) {
        alert('输入内容不能为空')
        return false
      }
      if (n === 1) {
        var query = {'typ': 1,'md5': m, 'content': this.content, 'anonym': this.anonym, 'stype': y, 'publishdate': z}
      }

      if (n === 2) {
        var query = {'typ': 2,'md5': m, 'content': this.content, 'anonym': this.anonym}
      }
      if (this.pid) {
        query.pid = this.pid
      }
      $.ajax({
        url: apiUrl('/V1.0.0/notice/addcomment'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        if (response.status === 0) {
          alert('评论成功')
          this.showComments = true
          // this.cpwpage = 1
          $(window).scrollTop(0)
          this.getCommentList(1, n, m)
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/notice/commentMix.js
 **/